import FeedbackReply from './FeedbackReply'
import FeedbackReceipt from './FeedbackReceipt'
import {connect} from 'react-redux'

class FeedbackDetail extends React.Component {
  render () {
    let {
      feedbacks,
      feedbackMessages,
      onSubmitReply,
      transactionDetail,
      feedbackType,
      feedbackMode
    } = this.props

    return (
      <div className='col-md-12 no-padding' id='customer-feedback-detail'>
        <FeedbackReply
          feedbacks={feedbacks}
          feedbackMessages={feedbackMessages}
          onSubmit={onSubmitReply}
          feedbackType={feedbackType}
          feedbackMode={feedbackMode}
        />
        <FeedbackReceipt
          transactionDetail={transactionDetail}
        />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    data: {
      customers: {
        feedback: state.customers.feedback
      }
    }
  }
}

FeedbackDetail.propTypes = {
  feedbackMessages: React.PropTypes.object,
  transactionDetail: React.PropTypes.object,
  onSubmitReply: React.PropTypes.func,
  feedbackType: React.PropTypes.string,
  feedbackMode: React.PropTypes.string
}

export default connect(mapStateToProps)(FeedbackDetail)



// WEBPACK FOOTER //
// ./app/pages/Customers/Feedback/FeedbackDetail/FeedbackDetail.js